import { useState, useEffect, useCallback } from 'react';
import styles from './index.module.sass';
import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'react-i18next';

// Components
import OrderCard from '../../../OrderCard';
import SectionTitle from '../../../SectionTitle';
import TableComponent from '../../../TableComponent';
import getInvoicesDetail from '../../../Queries/GetInvoicesDetail';
import Alert from '../../../Alert';
import ReshipmentAddressForm from '../ReshipmentAddressForm';
import ReshipmentPayment from '../ReshipmentPayment';
import CircularProgress from '@mui/material/CircularProgress';

// Queries
import GetTokenIrelandPay from '../../../Queries/GetTokenIrelandPay';

const OrderDetail = (props) => {
  const { device, setSessionMessage, order, setOrderSelected, history, blackList } = props;
  const pedido = order.Pedido;
  const { screenSize } = device;
  const { t } = useTranslation(['myOrders', 'reshipments']);
  const tableItems = t('tableItems', { returnObjects: true });
  const [loading, setLoading] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [detailInvoices, setdetailInvoices] = useState([]);
  const [response, setresponse] = useState('');
  const [openForm, setOpenForm] = useState(false);
  const [reshipmentAddress, setReshipmentAddress] = useState(order);
  const [openPayment, setOpenPayment] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentToken, setPaymentToken] = useState('');

  const payForReshipment = useCallback(async () => {
    if (reshipmentAddress.Estatus === 'SP') {
      setAlertText(t('reshipments:paidReshipment'));
      setOpen(true);
      return;
    }

    if (!reshipmentAddress.CodigoPostal) {
      setAlertText(t('reshipments:needAnAddress'));
      setOpen(true);
      return;
    }

    if (!reshipmentAddress.Paqueteria) {
      setAlertText(t('reshipments:noParcelSelected'));
      setOpen(true);
      return;
    }

    setPaymentLoading(true);

    const irelandPayToken = await GetTokenIrelandPay({
      jsonBody: {
        idioma: 1,
        amount: reshipmentAddress.Total,
        orderNumber: reshipmentAddress.Pedido,
      },
    });

    const { token = '', message = '', typeMessage = 'error' } = irelandPayToken;

    setSessionMessage(message);

    if (token && typeMessage === 'success') {
      setPaymentToken(token);
      setOpenPayment(true);
    } else {
      setPaymentLoading(false);
      setAlertText(message);
      setOpen(true);
      window.scrollTo(0, 0);
    }

    setPaymentLoading(false);
  }, [
    reshipmentAddress.CodigoPostal,
    reshipmentAddress.Estatus,
    reshipmentAddress.Paqueteria,
    reshipmentAddress.Pedido,
    reshipmentAddress.Total,
    setSessionMessage,
    t,
  ]);

  useEffect(() => {
    async function get_Detail_Invoice() {
      setLoading(true);

      const response = await getInvoicesDetail(pedido);
      setresponse(response);
      const { typeMessage = 'error', message = '', InvoicesDetail = [] } = response;

      setSessionMessage(message);

      if (typeMessage === 'error') {
        if (message === '498' || message === '499') return false;
        setAlertText(message);
        setOpen(true);
      } else {
        setdetailInvoices(InvoicesDetail);
      }

      setLoading(false);
    }
    get_Detail_Invoice();
  }, [setSessionMessage, pedido]);

  return (
    <>
      {(openForm || openPayment) && ( // 411111 999
        <div className={`${styles.overlay} ${screenSize !== 'desktop' ? styles.mobile : ''}`}>
          <div
            className={styles.closeForm}
            onClick={() => {
              setOpenForm(false);
              setOpenPayment(false);
            }}>
            <i className='material-icons-outlined'>close</i>
          </div>
          {openForm && (
            <div>
              <OrderCard>
                <ReshipmentAddressForm
                  blackList={blackList}
                  order={reshipmentAddress}
                  device={device}
                  setSessionMessage={setSessionMessage}
                  callback={() => {
                    setOpenForm(false);
                  }}
                  setReshipmentAddress={setReshipmentAddress}
                />
              </OrderCard>
            </div>
          )}
          {openPayment && (
            <ReshipmentPayment
              device={device}
              setSessionMessage={setSessionMessage}
              paymentToken={paymentToken}
              history={history}
              callback={() => {
                setOpenPayment(false);
              }}
            />
          )}
        </div>
      )}
      <div className={`${styles.container} ${styles[screenSize]}`}>
        <div className={styles.orderHeader}>
          <div className={styles.return} onClick={() => setOrderSelected(null)}>
            <i className='material-icons-outlined'>navigate_before</i>
            <span className={styles.returnText}>{t('return')}</span>
          </div>
        </div>
        <SectionTitle title={t('titleDetail')} subtitle={t('subTitleDetail')} />
        <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />

        <div className={styles.details}>
          <div className={styles.bloque}>
            <OrderCard
              customStyles={styles.orderCard}
              title={(screenSize === 'phone' && t('order')) || null}>
              {screenSize !== 'phone' && <div className={styles.titleOrder}>{t('order')}</div>}
              <div className={styles.textOrder}>{response.noPedido}</div>
              <div className={styles.titleOrder}>{t('date')}</div>
              <div className={styles.textOrder}>{response.fecha}</div>
            </OrderCard>
          </div>
          <div className={styles.bloque}>
            <OrderCard
              customStyles={styles.orderCard}
              title={(screenSize === 'phone' && t('invoice')) || null}>
              {screenSize !== 'phone' && <div className={styles.titleOrder}>{t('invoice')}</div>}
              <div className={styles.textOrder}>
                <span className={styles.nameOrder}>{t('kit')}</span> {response.kit}
              </div>
              <div className={styles.textOrder}>
                <span className={styles.nameOrder}>{t('consultora')} </span>
                {response.nombreConsultora}
              </div>
            </OrderCard>
          </div>
          <div className={styles.bloque}>
            <OrderCard
              customStyles={styles.orderCard}
              title={(screenSize === 'phone' && t('address')) || null}>
              {screenSize !== 'phone' && <div className={styles.titleOrder}>{t('address')}</div>}
              <div className={styles.textOrder}>
                {reshipmentAddress.CodigoPostal ? (
                  `${reshipmentAddress?.Line1} ${reshipmentAddress?.Line2} ${reshipmentAddress?.Line3} ${reshipmentAddress?.Ciudad} ${reshipmentAddress?.Estado}`
                ) : (
                  <label style={{ color: 'red' }}>{t('reshipments:noAddress')}</label>
                )}
              </div>
              <div className={styles.titleOrder}>{t('reshipments:parcel')}</div>
              <div className={styles.textOrder}>{reshipmentAddress.Paqueteria}</div>
              {reshipmentAddress.Estatus === 'SE' && (
                <div className={styles.changeAddressButton} onClick={() => setOpenForm(true)}>
                  {t('reshipments:changeAddress')}
                </div>
              )}
            </OrderCard>
          </div>
          <div className={styles.bloque}>
            <OrderCard
              customStyles={styles.orderCard}
              title={(screenSize === 'phone' && t('reshipments:reshipmentCost')) || null}>
              {screenSize !== 'phone' && (
                <div className={styles.titleOrder}>{t('reshipments:reshipmentCost')}</div>
              )}
              <div className={styles.textOrder}>
                <span className={styles.nameOrder}>{t('reshipments:cost')}: </span>
                <span className={styles.titleOrder}>${reshipmentAddress.CostoFlete}</span>
              </div>
              <div className={styles.textOrder}>
                <span className={styles.nameOrder}>{t('reshipments:signature')}: </span>
                <span className={styles.titleOrder}>${reshipmentAddress.CostoFirma}</span>
              </div>
              <div className={styles.textOrder}>
                <span className={styles.nameOrder}>{t('reshipments:taxes')}: </span>
                <span className={styles.titleOrder}>${reshipmentAddress.Impuesto}</span>
              </div>
              <div className={styles.textOrder}>
                <span className={styles.nameOrder}>{t('reshipments:total')}: </span>
                <span className={styles.titleOrder}>${reshipmentAddress.Total}</span>
              </div>

              {reshipmentAddress.Estatus === 'SE' && (
                <div className={styles.changeAddressButton} onClick={payForReshipment}>
                  {paymentLoading ? (
                    <CircularProgress className={styles.finishLoading} />
                  ) : (
                    t('reshipments:payReshipment')
                  )}
                </div>
              )}

              {(reshipmentAddress.Estatus === 'SP' || reshipmentAddress.Estatus === 'SA') && (
                <div className={styles.paidReshipment}>{t('reshipments:paidReshipment')}</div>
              )}
            </OrderCard>
          </div>
        </div>

        <div className={styles.divBloque}>
          <OrderCard>
            {(loading && (
              <div className={styles.bottomSkeleton}>
                <TableComponent
                  screenSize={screenSize}
                  tableData={detailInvoices}
                  tableItems={tableItems}
                />
                <div className={styles.totalsSkeleton}>
                  <Skeleton variant='rectangular' className={styles.loadingText} />
                  <Skeleton variant='rectangular' className={styles.loadingText} />
                  <Skeleton variant='rectangular' className={styles.loadingText} />
                </div>
              </div>
            )) || (
              <>
                <TableComponent
                  screenSize={screenSize}
                  tableData={detailInvoices}
                  tableItems={tableItems}
                />
                {screenSize === 'phone' ? (
                  <div className={styles.totals}>
                    <div className={styles.bottomPage}>
                      <div className={styles.totals}>
                        <div className={styles.totalText}>{t('subtotal')}</div>
                        <div className={styles.totalNumber}>${response.subtotal}</div>
                      </div>

                      <div className={styles.totals}>
                        <div className={styles.totalText}>{t('envio')}</div>
                        <div className={styles.totalNumber}>${response.envio}</div>
                      </div>

                      <div className={styles.totals}>
                        <div className={styles.totalText}>
                          {(process.env.REACT_APP_COUNTRY === 'MX' && t('iva')) || t('taxes')}
                        </div>
                        <div className={styles.totalNumber}>${response.impuestos}</div>
                      </div>

                      <div className={styles.totals}>
                        <div className={styles.totalTextMobile}>{t('total')}</div>
                        <div className={styles.totalNumberMobile}>${response.total}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={styles.totals}>
                    <div className={styles.linkDownload}>
                      {response.url && (
                        <>
                          <div className={styles.download}>
                            <i className={`material-icons-outlined `}>picture_as_pdf</i>
                            <div className={styles.underline}>
                              <a href={response.url} target='_blank' rel='noreferrer'>
                                &nbsp;{t('download')}
                              </a>
                            </div>
                          </div>

                          {process.env.REACT_APP_COUNTRY === 'MX' && (
                            <div className={styles.download}>
                              <i className={`material-icons-outlined `}>picture_as_pdf</i>
                              <div className={styles.underline}>
                                <a href={response.urlXML} target='_blank' rel='noreferrer'>
                                  &nbsp;{t('downloadXML')}
                                </a>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                    <div className={styles.bottomPage}>
                      <div className={styles.totals}>
                        <div className={styles.totalText}>{t('subtotal')}</div>
                        <div className={styles.totalNumber}>${response.subtotal}</div>
                      </div>

                      <div className={styles.totals}>
                        <div className={styles.totalText}>{t('envio')}</div>
                        <div className={styles.totalNumber}>${response.envio}</div>
                      </div>

                      <div className={styles.totals}>
                        <div className={styles.totalText}>
                          {(process.env.REACT_APP_COUNTRY === 'MX' && t('iva')) || t('taxes')}
                        </div>
                        <div className={styles.totalNumber}>${response.impuestos}</div>
                      </div>

                      <div className={styles.totals}>
                        <div className={`${styles.totalText} ${styles.bigTotal}`}>{t('total')}</div>
                        <div className={`${styles.totalNumber} ${styles.bigTotal}`}>
                          ${response.total}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </OrderCard>
        </div>
        {screenSize === 'phone' && (
          <div className={styles.linkDownload}>
            {response.url && (
              <>
                <div className={styles.download}>
                  <i className={`material-icons-outlined `}>picture_as_pdf</i>
                  <div className={styles.underline}>
                    <a href={response.url} target='_blank' rel='noreferrer'>
                      &nbsp;{t('download')}
                    </a>
                  </div>
                </div>
                {process.env.REACT_APP_COUNTRY === 'MX' && (
                  <div className={styles.download}>
                    <i className={`material-icons-outlined `}>picture_as_pdf</i>
                    <div className={styles.underline}>
                      <a href={response.urlXML} target='_blank' rel='noreferrer'>
                        &nbsp;{t('downloadXML')}
                      </a>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default OrderDetail;
